<!-- Footer -->
<div class="loader" *ngIf="!load_flag"></div>
<footer id="sticky-footer" style="padding: 0px !important; bottom: 0;">
    <div id="sticky-div" class="text-center">
        <div class="row" (click)="confPedido(1)" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false"  aria-controls="collapseExample">
            <div class="col-3 circulob" style="padding: 0px 5px;">
                <img src="../../../../assets/images/smallshi-05.png" alt="" >
            </div>
            <!-- <div class="col-2"><b>{{ numProductos }}</b> </div> -->
            <div class="col-6" style="padding: 0px 5px;">
                <!-- <a class="" style="text-decoration-line: none; text-decoration-color: white;" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                    Ver Carrito
                  </a> -->
                <B >VER CARRITO<br>
                    {{ vaLFacTotal | currency:'COP':'$':'.2' }}
                </B>

            </div>

            <div class="col-3 circulob" style="width: 72px; height: 36px; padding: 0px 5px;">
                <img src="../../../../assets/images/elementos-83.png" alt="" style="width: 86px; height: 40px;">
            </div>
        </div>
    </div>
    <div class="collapse" id="collapseExample">
        <div class="card card-body" *ngIf="!flagMedioPago">
            <div class="carrito-body">
                <div class="row">
                    <div class="col-12" style="text-align: center; padding: 6px;">

                        <b style="font-size: 20px;">Resumen de tus compras</b>
                    </div>
                </div>
                <div id="cont-carrito">
                    <div class="row">
                        <div class="col-4">
                            <small><p class="card-title">Nombre</p></small>
                        </div>
                        <div class="col-2" style="text-align: center;">
                            <p class="card-title">Cantidad</p>
                        </div>
                        <div class="col-3">
                            <p class="card-title">Valor unitario</p>
                        </div>
                        <div class="col-3">
                            <p class="card-title">Valor items</p>
                        </div>
                    </div>

                </div>
                <div *ngFor="let producto of productos, let i = index" id="cont-carrito">
                    <div *ngIf="producto.cantidad > 0" class="row">
                        <div class="col-4">
                            <small><p class="card-title">{{producto.title}}</p></small>
                        </div>
                        <div class="col-2">
                            <p class="card-title">{{producto.cantidad}}</p>
                        </div>
                        <div class="col-3">
                            <p class="card-title">{{producto.price | currency:'COP':'$':'.2'}}</p>
                        </div>
                        <div class="col-3">
                            <p class="card-title" style="font-size: 12px;">{{producto.price * producto.cantidad | currency:'COP':'$':'.2'}}</p>
                        </div>
                    </div>
                    <hr *ngIf="producto.cantidad > 0">
                </div>

            </div>
            <div class="row">
                <div class="col-5 ff-regular" style="font-size: 1rem;">SUB TOTAL</div>
                <div class="col-1" style="font-size: 1rem;"> </div>
                <div class="col-5 ff-regular" style="text-align: right;">
                    <h4 style="font-size: 1rem; color:orangered;">{{ valorFactura | currency:'COP':'$':'.2'}}</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-5 ff-regular" style="font-size: 1rem;">IMPUESTOS</div>
                <div class="col-1" style="font-size: 1.1rem;"> </div>
                <div class="col-5 ff-regular" style="text-align: right;">
                    <h4 style="font-size: 1rem; color:orangered;">{{ ValorImpuestos | currency:'COP':'$':'.2'}}</h4>
                </div>
            </div>
            <!-- <div class="row" *ngIf="formaEntrega === '1'">
                <div class="col-5" style="font-size: 1.1rem;">ENVÍOS</div>
                <div class="col-1" style="font-size: 1.1rem;"> </div>
                <div class="col-5" style="text-align: right;">
                    <h4 style="font-size: 1.1rem; color:orangered;">{{costoDomicilio | currency:'COP':'$':'.2'}}</h4>
                </div>
            </div> -->
            <div class="row">
                <div class="col-5 ff-semiBold" style="font-size: 1.1rem;">IMPORTE TOTAL</div>
                <div class="col-1" style="font-size: 1.2rem;"> </div>
                <div class="col-5 ff-semiBold" style="text-align: right;">
                    <h4 style="font-size: 1.1rem; color:orangered;">{{ vaLFacTotal | currency:'COP':'$':'.2'}}</h4>
                </div>
            </div>
            <div class="row" *ngIf="btnDelivery" style="margin-top: 10px; margin-bottom: 10px;">
                <div class="col-12">
                    <button type="button" class="btn btn-otl-pedido btn-block" data-button="true" (click)="openModal(contenido)" alt="..." data-toggle="modal" data-target="#staticBackdrop"><b data-button="true">Datos de envío</b></button>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button type="button" [disabled]="disabled_btn" data-button="true" class="btn btn-otl-pedido btn-block" (click)="confPedido(0)"><b data-button="true">Confirmar Pedido</b></button>
                    <!-- <button type="button" [disabled]="disabled_btn" class="btn btn-otl-pedido btn-block" (click)="confPedido(0)"><b>Confirmar Pedido</b></button> -->
                </div>
            </div>

        </div>
        <div class="card card-body animated fadeInRight" *ngIf="flagMedioPago">
            <div class="carrito-body">
                <div class="row" style=" text-align: center;">
                    <ng-container *ngIf="environment.options.numeroHabitacion">
                        <div class="col-3 d-flex align-content-center">
                            <label class="m-auto" for="numeroHabitacion">Número de Habitación:</label>
                        </div>
                        <div class="col-9">
                            <div class="input-group">
                                <input [(ngModel)]="numeroHabitacion"  class="form-control" type="number" id="numeroHabitacion">
                            </div>
                            <div *ngIf="error.show" style="color: red;">
                                {{error.message}}
                            </div>
                        </div>
                    </ng-container>

                    <div data-button="true" class="col-12" style="text-align: center; padding: 6px;">
                        <b data-button="true" style="font-size: 18px;">Envianos tus comentarios.</b>
                    </div>
                    <div data-button="true" class="input-group">
                        <textarea data-button="true" class="form-control" id="observacionesHtml" style=" height: 40vh;" placeholder="Observaciones." aria-label="With textarea"></textarea>
                    </div>
                </div>
            </div>
            <div data-button="true" class="row" *ngIf="flujo === '2'">
                <div data-button="true" class="col-12">
                    <button data-button="true" type="button" class="btn btn-otl-pedido btn-block" (click)="crearPedidoComercio()"><b>Enviar mi orden</b></button>
                </div>
            </div>
            <div data-button="true" class="row" *ngIf="flujo === '1'">
                <div data-button="true" class="col-12">
                    <button data-button="true" type="button" class="btn btn-otl-pedido btn-block" (click)="crearPedido()"><b>Enviar mi orden</b></button>
                </div>
            </div>
        </div>
    </div>
</footer>

<ng-template #contenido let-modal>

    <div class="modal-header " data-button="true">
        <h5 class="modal-title" data-button="true" id="staticBackdropLabel">Información de envio</h5>
        <button type="button" data-button="true" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrarDelivery()">
                <span data-button="true" aria-hidden="true">&times;</span>
              </button>
    </div>
    <form data-button="true" autocomplete="off" *ngIf="controlDelivery == 1" [formGroup]="formularioDelivery" (ngSubmit)="guardarFormDelivery()">
        <div data-button="true" class="modal-body">

            <div data-button="true" class="row">
                <div data-button="true" class="col-12 row-modal">
                    <select data-button="true" id="_forma_entrega" class="form-control f2-control" formControlName="_forma_entrega" [class.is-invalid]="forma_entrega_noValido">
                                    <option data-button="true" value="" selected>Forma de entrega</option>
                                    <option data-button="true" value="0" selected>Pick-up</option>
                                <option data-button="true"  value="1">Delivery</option>
                                <option data-button="true"  value="2">Local</option>
                              </select>
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <input data-button="true" type="email" class="form-control" placeholder="email" formControlName="_email" [class.is-invalid]="correoNoValido">
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <input data-button="true" type="text" class="form-control" placeholder="Nombres" formControlName="_nombres" [class.is-invalid]="nombreNoValido">
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <input data-button="true" type="text" class="form-control" placeholder="Apellidos" formControlName="_apellidos" [class.is-invalid]="apellidoNoValido">
                </div>
                <div class="col-12 row-modal">
                    <input data-button="true" type="text" class="form-control" placeholder="Celular" formControlName="_celular" [class.is-invalid]="celularNoValido">
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <input data-button="true" type="text" class="form-control" placeholder="Cedula del cliente" formControlName="_cedula" [class.is-invalid]="cedulaNoValido">
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <select data-button="true" id="_provincia" (change)="getDistrito($event)" class="form-control f2-control" formControlName="_provincia" [class.is-invalid]="provinciaNoValido">
                                <option data-button="true" value="" selected>Provincias</option>
                                <option data-button="true" *ngFor="let provincia of provincias" [value]="provincia.id_provincia">{{provincia.provincia}}</option>
                              </select>
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <select id="_distrito" data-button="true"  (change)="getCorregimiento($event)" class="form-control f2-control" formControlName="_distrito" [class.is-invalid]="forma_entrega_noValido">
                                <option data-button="true" value="" selected>Distrito</option>
                                <option data-button="true" *ngFor="let distrito of distritos"  [value]="distrito.id_distrito">{{distrito.distrito}}</option>
                              </select>
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <select data-button="true" id="_corregimiento" (change)="getBarrio($event)" class="form-control f2-control" formControlName="_corregimiento" [class.is-invalid]="forma_entrega_noValido">
                                <option data-button="true" value="" selected>Corregimiento</option>
                                <option data-button="true" *ngFor="let corregimiento of corregimientos"  [value]="corregimiento.id_corregimiento">{{corregimiento.corregimiento}}</option>
                              </select>
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <select data-button="true" id="_barrio" class="form-control f2-control" (change)="setBarrio($event)" formControlName="_barrio" [class.is-invalid]="forma_entrega_noValido">
                                <option data-button="true" value="" selected>Barrio</option>
                                <option data-button="true" *ngFor="let barrio of barrios"  value="barrio.id_barrio">{{barrio.barrio}}</option>
                              </select>
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <input data-button="true" type="text" class="form-control" placeholder="Dirección" formControlName="_direccion" [class.is-invalid]="forma_entrega_noValido">
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <input data-button="true" type="text" class="form-control" placeholder="Observaciones de la entrega" formControlName="_obs_entrega" [class.is-invalid]="forma_entrega_noValido">
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <input data-button="true" type="text" class="form-control" placeholder="Calle" formControlName="_calle" [class.is-invalid]="forma_entrega_noValido">
                </div>
                <div data-button="true" class="col-12 row-modal">
                    <input data-button="true" type="text" class="form-control" placeholder="Casa o Apartamento" formControlName="_casaApto" [class.is-invalid]="forma_entrega_noValido">
                </div>
                <hr data-button="true">
            </div>
        </div>


        <div data-button="true" class="modal-footer">
            <div data-button="true" class="row">
                <div data-button="true" class="col-12 row-modal">
                    <button data-button="true" type="submit" class="btn btn-otl-pedido btn-block">
                                    Guardar
                                  </button>
                </div>

            </div>
        </div>
    </form>
    <form data-button="true" *ngIf="controlDelivery == 0" [formGroup]="formularioDelivery" (ngSubmit)="guardarFormDelivery2()">
        <div data-button="true"  class="modal-body">

            <div data-button="true" class="row">
                <div data-button="true" class="col-12 row-modal">
                    <select data-button="true" id="_forma_entrega" class="form-control f2-control" (change)="setdeliveryIship($event)" formControlName="_forma_entrega" [class.is-invalid]="forma_entrega_noValido">
                                <option  data-button="true" value="" selected>Forma de entrega</option>
                                <option  data-button="true" value="0" selected>Pick-up</option>
                                <option  data-button="true" value="1" *ngIf="small.delivery">Delivery</option>
                    </select>
                </div>
                <div data-button="true" class="col-12" *ngIf="deliveryship == 1" style="padding: 0px;">
                    <agm-map data-button="true" [latitude]="location[0]" [longitude]="location[1]" [zoom]="18" (mapClick)="move( $event )">
                        <agm-marker data-button="true" [latitude]="location[0]" [longitude]="location[1]" [iconUrl]="{ url:'../../../../assets/images/iconos-12.png', scaledSize: { width: 32, height: 40, anchor : {x:19, y:19} }}"></agm-marker>
                        <agm-marker data-button="true" [latitude]="latComercio" [longitude]="lngComercio" [iconUrl]="{ url:'../../../../assets/images/delivery.png', scaledSize: { width: 32, height: 40, anchor : {x:19, y:19} }}"></agm-marker>
                    </agm-map>
                </div>
                <!-- <div *ngIf="deliveryship == 1" class="col-4">
                    <div class="icon-tienda">
                        <img class="animated fadeIn fast" (click)="sellectais('PA', contenido)" src="../../../../assets/images/PA_B.svg" alt="">

                    </div>
                </div>
                <div *ngIf="deliveryship == 1" class="col-4">
                    <div class="icon-tienda">
                        <img class="animated fadeIn fast" (click)="sellectais('CO', contenido)" src="../../../../assets/images/CO_B2.jpg" alt="">

                    </div>
                </div>
                <div *ngIf="deliveryship == 1" class="col-4">
                    <div class="icon-tienda">
                        <img class="animated fadeIn fast" (click)="sellectais('MX', contenido)" src="../../../../assets/images/MX_B.svg" alt="">

                    </div>
                </div>
                <hr> -->
                <div data-button="true" *ngIf="deliveryship == 1" class="col-12 row-modal">
                    <p style="color: red;">{{msnDelivery}}</p>
                </div>
                <div data-button="true" *ngIf="deliveryship == 1" class="col-12 row-modal">
                    <input ngx-google-places-autocomplete [options]='options' #placesRef="ngx-places" class="form-control" formControlName="_calle" [class.is-invalid]="calleNoValido" (onAddressChange)="handleAddressChange($event)" />
                </div>
                <!-- <div *ngIf="deliveryship == 1" class="col-12 row-modal">
                    <input type="text" class="form-control" placeholder="Calle" formControlName="_calle">
                /div> -->
                <div data-button="true" *ngIf="deliveryship == 1" class="col-12 row-modal">
                    <input type="text" class="form-control" placeholder="Casa o Apartamento" formControlName="_casaApto" [class.is-invalid]="aptoNoValido" value="[data._casaApto]">
                </div>
            </div>
            <div data-button="true" class="modal-footer">
                <div data-button="true" class="row">
                    <div data-button="true" class="col-12 row-modal">
                        <button data-button="true" type="submit" class="btn btn-otl-pedido btn-block">
                                    Guardar
                                  </button>
                    </div>

                </div>
            </div>
        </div>
    </form>



</ng-template>
